import { atom } from 'recoil';
export const localDocumentMetadataAtom = atom({
    key: '@zurich/party/local/documentMetadata',
    default: {},
});
export const localModificationReason = atom({
    key: '@zurich/party/local/modificatinReason',
    default: undefined,
});
export const fileUploadDialogAtom = atom({
    key: '@zurich/party/local/fileUploadDialog',
    default: {},
});
